import {ErrorHandler, LOCALE_ID, NgModule, provideBrowserGlobalErrorListeners} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AddressEdit } from './Akte/Controlls/AddressEdit';
import { DateSelect } from './Akte/Controlls/DateSelect';
import { Combobox, ComboboxInput, ComboboxPopupContainer } from '@angular/aria/combobox';
import { Listbox, Option } from '@angular/aria/listbox';
import { ToastsContainer } from './Akte/Services/Toasts/ToastsContainer';
import { RouterModule } from '@angular/router';
import { VersandStepper } from './Componente/versand-stepper/versand-stepper';
import { AuthorizeDirective } from './Directives/AuthorizationDirective';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeDe from '@angular/common/locales/de';
import { GeneratingPopup } from './Main/Pages/Abrechnung/Popups/generating-popup/generating-popup';
import { MissingInbetriebnahmeListe } from './Main/Pages/Abrechnung/Popups/missing-inbetriebnahme-liste/missing-inbetriebnahme-liste';
import { FileUploadExport } from './Main/Pages/Abrechnung/Popups/file-upload-export/file-upload-export';
import {GlobalErrorHandler} from '../GlobalErrorHandler';


registerLocaleData(localeDe);

@NgModule({
  declarations: [App],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    AddressEdit,
    Combobox,
    DateSelect,
    ComboboxInput,
    ComboboxPopupContainer,
    ToastsContainer,
    RouterModule,
    Listbox,
    AuthorizeDirective,
    CurrencyPipe,
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    CurrencyPipe,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  bootstrap: [App],
})
export class AppModule {}
